import { Link } from "react-router-dom";
import { Button } from "./ui/button";

export function NotFoundPanel() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[40vh] gap-4 text-center">
      <h1 className="text-3xl font-semibold tracking-tight">Page not found</h1>
      <p className="text-ink-dim text-sm">
        The page you are looking for does not exist or you do not have access.
      </p>
      <Button asChild variant="secondary" size="sm">
        <Link to="/">Back to dashboard</Link>
      </Button>
    </div>
  );
}
